import {Component, effect, input, OnInit, output, signal, untracked} from '@angular/core';
import {SelectItemGroup} from 'primeng/api';
import {SiteZoneDto} from '../selection-zone/model/site-zone.dto';
import {SiteService} from '../../services/site.service';
import {ZoneDeTravailAvecSiteDto} from '../../dto/zone-de-travail-avec-site.dto';

@Component({
	selector: 'app-gestion-zones-autorisees',
	templateUrl: './gestion-zones-autorisees.component.html',
	styleUrl: './gestion-zones-autorisees.component.scss'
})
export class GestionZonesAutoriseesComponent implements OnInit {

	zonesAutorisees = input<ZoneDeTravailAvecSiteDto[]>([]);

	onAjoutRetraitZonesAutorisees = output<ZoneDeTravailAvecSiteDto[]>();

	groupesZonesDropdown = signal<SelectItemGroup[]>([]);
	_zonesAutorisees = signal<ZoneDeTravailAvecSiteDto[]>([]);

	zonesSelectionneesIds: number[] = [];
	sitesZones: SiteZoneDto[] = [];

	constructor(private siteService: SiteService) {
		effect(() => {
			const zonesAutorisees = this.zonesAutorisees();

			untracked(() => {
				this._zonesAutorisees.set(zonesAutorisees);
				this.mettreAJourGroupesZonesDropdown();
			});
		});
	}

	ngOnInit(): void {
		this.recupererZonesPrivees();
	}

	/**
	 * Récupère les zones privées.
	 */
	recupererZonesPrivees(): void {
		this.siteService.rechercherZonesPrivees()
			.subscribe({
				next: sitesZonesDto => {
					this.sitesZones = sitesZonesDto;

					this._zonesAutorisees.set(this.zonesAutorisees());

					this.mettreAJourGroupesZonesDropdown();
				}
			});
	}

	/**
	 * Met à jour le contenu du dropdown en retirant les zones déjà autorisées.
	 */
	mettreAJourGroupesZonesDropdown(): void {
		const groupesZones: SelectItemGroup[] = [];

		const zonesAutoriseesIds = this._zonesAutorisees().map(zone => zone.id);

		this.sitesZones
			// On enlève tous les sites qui ont toutes leurs zones déjà autorisées.
			.filter(siteZone => {
				const zonesIds = siteZone.zones.map(zone => zone.id);
				return !zonesIds.every(id => zonesAutoriseesIds.includes(id));
			})
			.forEach((siteZone) => {
				groupesZones.push({
					label: siteZone.nom,
					value: siteZone.id,
					items: siteZone.zones
						// On enlève toutes les zones qui sont autorisées
						.filter(zone => !zonesAutoriseesIds.includes(zone.id))
						.map(zone => {
							return {label: zone.nom, value: zone.id};
						})
				});
			});

		this.groupesZonesDropdown.set(groupesZones);
	}

	/**
	 * Ajoute les zones autorisées et les envois au parent.
	 */
	onClickAjouterZonesAutorisees(): void {
		const zonesAutorisees: ZoneDeTravailAvecSiteDto[] = [];

		this.sitesZones.forEach(site => {
			site.zones.forEach(zone => {
				if (this.zonesSelectionneesIds.includes(zone.id)) {
					zonesAutorisees.push(new ZoneDeTravailAvecSiteDto(zone.id, zone.nom, site.nom));
				}
			});
		});

		this._zonesAutorisees.update((zones) => {
			zones.push(...zonesAutorisees);
			return zones;
		});

		this.onAjoutRetraitZonesAutorisees.emit(this._zonesAutorisees());

		this.mettreAJourGroupesZonesDropdown();
		this.zonesSelectionneesIds.length = 0;
	}

	recupererLabelZone(zone: ZoneDeTravailAvecSiteDto): string {
		return `${zone.nomDuSite} - ${zone.nom}`;
	}

	/**
	 * Retire la zone qui n'est plus autorisée et notifie le parent.
	 * @param zoneSupprimee la zone qui n'est plus autorisée.
	 */
	onRemoveZoneAutorisee(zoneSupprimee: ZoneDeTravailAvecSiteDto): void {
		this._zonesAutorisees.update((zones) => zones.filter(zone => zone.id !== zoneSupprimee.id));
		this.onAjoutRetraitZonesAutorisees.emit(this._zonesAutorisees());
		this.mettreAJourGroupesZonesDropdown();
	}
}
